import { FC, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Home from "./views/home";
import Page404 from "./views/Page404";
import Login from "./views/auth/Login";
import Register from "./views/auth/Register";

import "react-edit-text/dist/index.css";

// restaurant admin
import Admin from "./views/restaurant/Admin";
import PrivateRoute from "./ProtectedRoute";
import Guide from "./views/Guide";

// components
import Footer from "./components/layout/Footer";
import mainStore from "./store/index";
import MenuId from "./views/Menu_id";

// dashboard super admin
import Dashboard from "./views/super/Dashboard";
import PrivateRouteAdmin from "./ProtectedRouteAdmin";
import Business from "./views/business";
import { PostValidateToken_API } from "./API";
import Calificame from "views/Calificame";
import MenuDashboard from "views/menu-dashboard";

// import { db, database } from "./firebase-config";
import { collection, getDocs, onSnapshot } from "firebase/firestore";
import { getDatabase, ref, onValue } from "firebase/database";

const App: FC = () => {
  const STORE = mainStore();

  // const userCollectionRef = collection(db, "analytics");

  useEffect(() => {
    STORE.handleUserlogged();
    STORE.saveUser();
    validateToken();
  }, []);

  const validateToken = async () => {
    const token = localStorage.getItem("token");
    // try {
    //   const da = await PostValidateToken_API(token);
    // } catch (error) {
    //   if (token) {
    //     STORE.handledLogged(false);
    //     localStorage.clear();
    //     window.location.reload();
    //   }
    // }
  };

  return (
    <>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/admin-restaurant"
            element={
              <PrivateRoute>
                <Admin />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard-administracion"
            element={
              <PrivateRouteAdmin>
                <Dashboard />
              </PrivateRouteAdmin>
            }
          />
          <Route
            path="/guide"
            element={
              <PrivateRouteAdmin>
                <Guide />
              </PrivateRouteAdmin>
            }
          />
          <Route
            path="/dashboard-menu"
            element={
              <PrivateRouteAdmin>
                <MenuDashboard />
              </PrivateRouteAdmin>
            }
          />
          {/* users public*/}
          <Route path="/" element={<Home />} />
          {/* <Route path="/restaurant/:id" element={<Restaurant />} /> */}
          <Route path="/menu/:id" element={<MenuId />} />
          <Route path="/calificame" element={<Calificame />} />
          <Route path="/business" element={<Business />} />
          <Route path="*" element={<Page404 />} />
        </Routes>
      </Router>
      <Footer />
    </>
  );
};

export default App;
